(function(){
  // Qty selector
  document.addEventListener('click', function(e){
    if(e.target.matches('.qty .minus, .qty .plus')){
      const input = e.target.parentElement.querySelector('input');
      let v = parseInt(input.value)||1;
      if(e.target.classList.contains('minus')) v=Math.max(1,v-1); else v++;
      input.value = v;
    }
    if(e.target.matches('[data-variant-option]')){
      const group = e.target.parentElement;
      group.querySelectorAll('.option-value').forEach(b=>b.classList.remove('active'));
      e.target.classList.add('active');
    }
  });

  // Add to cart (AJAX)
  document.addEventListener('submit', function(e){
    const form = e.target;
    if(!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const txt = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled=true; btn.innerHTML='Aggiunto ✓'; }
    fetch('/cart/add.js',{
      method:'POST', body:new FormData(form),
      headers:{'Accept':'application/json'}
    }).then(r=>r.json()).then(()=>fetch('/cart.js'))
      .then(r=>r.json()).then(c=>{
        const el = document.querySelector('.cart-count');
        if(el) el.textContent = c.item_count;
        setTimeout(()=>{if(btn){btn.disabled=false; btn.innerHTML=txt;}},1600);
      }).catch(()=>{if(btn){btn.disabled=false; btn.innerHTML=txt;}});
  });
})();

/* Search drawer + predictive search */
(function(){
  const drawer = document.getElementById('SearchDrawer');
  if(!drawer) return;
  const input = drawer.querySelector('#SearchInput');
  const resultsBox = drawer.querySelector('#SearchResults');
  const resultsGrid = drawer.querySelector('.suggest-products');

  function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; setTimeout(()=>input && input.focus(), 60); }
  function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-search-open]')){ e.preventDefault(); open(); }
    if(e.target.closest('[data-search-close]')){ e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

  let t;
  if(input){
    input.addEventListener('input', function(){
      const q = input.value.trim();
      clearTimeout(t);
      if(q.length < 2){ resultsBox.hidden = true; return; }
      t = setTimeout(()=>{
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(r=>r.json()).then(data=>{
            const items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if(!items.length){ resultsBox.hidden = true; return; }
            resultsGrid.innerHTML = items.map(p=>`
              <a href="${p.url}" class="suggest-product">
                <div class="suggest-thumb"><img src="${p.image||p.featured_image||''}" alt=""></div>
                <div><p class="suggest-name">${p.title}</p><p class="suggest-pr">${(p.price||'').toString().replace(/^\$/, '€')}</p></div>
              </a>`).join('');
            resultsBox.hidden = false;
          }).catch(()=>{ resultsBox.hidden = true; });
      }, 180);
    });
  }
})();

/* Collection filter drawer (mobile) */
(function(){
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-filter-toggle]')){
      const panel = document.querySelector('[data-filter-panel]');
      if(panel) panel.classList.toggle('is-open');
      document.body.classList.toggle('filter-locked', panel && panel.classList.contains('is-open'));
    }
  });
})();
